import styled from "styled-components";
import { VscStarFull, VscStarEmpty } from "react-icons/vsc";

const Container = styled.div`
  color: #1894e1;
`;

export function Rating({ value }) {
  return (
    <Container>
      {Array.from(Array(value)).map(() => (
        <VscStarFull />
      ))}
      {Array.from(Array(5 - value)).map(() => (
        <VscStarEmpty />
      ))}
    </Container>
  );
}